<template>
  <b-td
    :id="'tillage-table-' + rowNum"
    class="cell-table"
    :class="{
      'gray-bg': rowNum % 2 !== 0,
    }"
  >
    <div>
      <b-table-simple class="mb-0" width="100%">
        <b-tbody>
          <TillageRow
            v-for="tillage in tillageData"
            :addition-view="false"
            :cropId="cropId"
            :field="fieldId"
            :tillage="tillage"
            :key="tillage.idx"
            :rowIndex="tillageData.indexOf(tillage)"
            :year="year"
            @handle-copy="handleCopyTillage($event)"
            @bad-input="handleBadInput"
          />
        </b-tbody>
      </b-table-simple>
      <!-- <div
        v-if="!showAddition"
        class="btn btn-primary add-icon icon-column mr-0 pull-right"
        @click="showAddition = true"
      >
        <i class="fa fa-plus" />
      </div> -->
      <div v-if="showAddition" class="border">
        <div class="float-right mr-1 mt-1">
          <i class="fa fa-times-circle fa-2x" @click="resetTillageToAdd" />
        </div>
        <div class="addition-container">
          <b-table-simple class="mt-4" width="100%">
            <b-tbody>
              <TillageRow
                :addition-view="true"
                :tillage="tillageToAdd"
                :year="year"
                @bad-input="handleBadInput"
              />
            </b-tbody>
          </b-table-simple>
          <div class="d-flex flex-row justify-content-between my-3">
            <div class="add-text">
              {{ showCopy ? "Copy" : "Add" }} to
              <!-- Re-enable for multifield add/copy -->
              <!-- {{ fieldYearToCopy.length }} -->
              additional years:
            </div>
            <div>
              <v-select-old
                multiple
                class="year-select"
                :options="years"
                v-model="yearSelected"
              />
            </div>
          </div>
          <!-- Re-enable for multifield add/copy -->
          <!-- <div class="d-flex flex-row justify-content-between mt-3">
            <div class="mb-3">
              <div class="d-flex flex-row">
                <span>Years: </span
                ><v-select-old
                  class="ml-2 year-select"
                  multiple
                  :options="years"
                  v-model="yearSelected"
                />
              </div>
            </div>
            <v-select-old
              multiple
              class="field-select"
              label="name"
              :options="allFields"
              :reduce="o => o.id"
              v-model="fieldYearToCopy"
            />
            <div>
              <button
                type="button"
                class="btn btn-primary py-2"
                @click="handleAddFieldsInFocus"
              >
                Select
                <span class="badge badge-pill badge-success">{{
                  selectedFields.length
                }}</span>
                Fields
              </button>
            </div>
          </div> -->
        </div>
      </div>
      <button
        v-if="showAddition"
        type="button"
        class="btn btn-success btn-lg btn-block"
        @click="handleSubmitTillage"
      >
        {{ showCopy ? "Copy" : "Submit" }} Tillage <i class="fa fa-plus" />
      </button>
    </div>
  </b-td>
</template>
<script>
import { cloneDeep } from "lodash"
import { mapActions, mapGetters } from "vuex"

import TillageRow from "@/components/spreadsheet/rows/TillageRow"
import { Defaults, Filter } from "@/store/modules"

export default {
  name: "TillageTable",
  components: {
    TillageRow,
  },
  props: {
    cropId: { type: Number },
    fieldId: { type: String },
    rowNum: { type: Number },
    tillageData: { type: Array },
    year: { type: String },
    years: { type: Array },
  },
  data() {
    return {
      showAddition: false,
      showCopy: false,
      tillageToAdd: {
        crop_id: { source: "User Input", value: null },
        date: { source: "User Input", value: null },
        depth: { source: "User Input", value: null },
        method: { source: "User Input", value: null },
      },
      fieldYearToCopy: [],
      yearSelected: [],
    }
  },
  computed: {
    ...mapGetters({
      allFields: Filter.Getters.getFields,
      selectedFields: Filter.Getters.getSelectedFields,
    }),
  },
  methods: {
    ...mapActions({
      // updateFieldSettingsByFieldYear:
      //   Defaults.Actions.updateFieldSettingsByFieldYear,
      updateMultipleFieldSettings: Defaults.Actions.updateMultipleFieldSettings,
    }),
    handleAddFieldsInFocus() {
      this.selectedFields.forEach(field => {
        if (
          !this.fieldYearToCopy.includes(this.fieldId) &&
          field.id !== this.fieldId
        ) {
          this.fieldYearToCopy.push(field.id)
        }
      })
    },
    handleCopyTillage(tillageToCopy) {
      this.showAddition = true
      this.showCopy = true

      this.tillageToAdd = cloneDeep(tillageToCopy)
    },
    handleSubmitTillage() {
      // TODO Re-enable for multi-field add/copy
      // if (this.showAddition && !this.showCopy) {
      //   this.fieldYearToCopy.push(this.fieldId)
      // }
      this.fieldYearToCopy.push(this.fieldId)
      this.updateMultipleFieldSettings({
        cropId: this.cropId,
        dataCategory: "tillages",
        fieldIds: this.fieldYearToCopy,
        rowData: this.tillageToAdd,
        years: this.yearSelected,
      })
      this.resetTillageToAdd()
    },
    resetTillageToAdd() {
      this.tillageToAdd = {
        crop_id: { source: "User Input", value: null },
        date: { source: "User Input", value: null },
        depth: { source: "User Input", value: null },
        method: { source: "User Input", value: null },
      }
      this.showAddition = false
      this.showCopy = false
      this.fieldYearToCopy = []
      this.yearSelected = [this.year]
    },
    handleBadInput(errorText) {
      this.$emit("bad-input", errorText)
    },
  },
  mounted() {
    if (this.year !== null) this.yearSelected.push(this.year)
  },
}
</script>
<style scoped>
.tillage-bg {
  background-color: #e5d6c8;
  /* background-color: #c4a381; */
}

.tillage-bg-dark {
  background-color: #c4a381;
  /* background-color: #997048; */
}

.gray-bg {
  background-color: #f6f7fb !important;
}

.addition-container {
  padding-left: 40px;
  padding-right: 84px;
}

.add-icon {
  background-color: #7774e7;
  color: white;
  cursor: pointer;
  padding-left: 14px;
}

.add-icon:hover,
.add-icon:focus {
  color: #ffffff;
  background-color: #8c8aeb;
}

.add-text {
  font-weight: 500;
  font-size: 14px;
}

.cell-table {
  padding: 0;
}

.complete {
  background-color: #00a200;
}

.arva-generated {
  background-color: #fedb80;
}

.alert {
  background-color: #cc0101;
}

.delete {
  color: #cc0101;
}

/* v-select-old widths */
.field-select {
  width: 160px;
}

.year-select {
  background-color: white !important;
  width: 110px;
  font-size: 13px;
}

/* column sizing */
.crop-column {
  min-width: 160px;
  max-width: 160px;
}

.date-column {
  min-width: 172px;
  max-width: 172px;
}

.depth-column {
  min-width: 84px;
  max-width: 84px;
}

.method-column {
  min-width: 180px;
  max-width: 180px;
}

.icon-column {
  min-width: 40px;
  max-width: 40px;
}

.icon-copy-column {
  min-width: 44px;
  max-width: 44px;
}
</style>
